export const Breakpoint = {
  EXTRA_SMALL: 360,
  SMALL: 475,
  MEDIUM: 767,
  LARGE: 991,
  EXTRA_LARGE: 1199,
  EXTRA_EXTRA_LARGE: 1399
} as const;
